import React, { FunctionComponent, memo } from 'react'
import RemoteControlledSwitch from '@sport1/react-elements/RemoteControlledSwitch'
import withTheme from '@sport1/react-elements/withTheme'
import lightTheme from '../../../themes/LightTheme'
import ThemeInterface from '../../../themes/ThemeInterface'
import { TestID } from '../../../utils/PropTypesDefinitions'

export type SwitchRemoteProps = {
    /**
     * function to be called when switch was pressed, should trigger a change to the value prop
     *
     * @TJS-type function
     * */
    onSwitchPress: (value: boolean) => void
    /**
     * value of the switch, must be changed remotely
     * */
    value: boolean
}

export type StyledRemoteSwitchProps = SwitchRemoteProps & {
    /**
     * @TJS-type object
     * */
    theme: ThemeInterface
} & TestID

const StyledRemoteControlledSwitch: FunctionComponent<StyledRemoteSwitchProps> = ({
    onSwitchPress,
    value,
    theme = lightTheme,
    testID,
}) => {
    return (
        <RemoteControlledSwitch
            offColor={theme.colors['keshi-3']}
            onColor={theme.colors.ORANGE}
            onSwitchPress={onSwitchPress}
            value={value}
            testID={testID}
        />
    )
}
export default memo(withTheme(StyledRemoteControlledSwitch)) as FunctionComponent<SwitchRemoteProps>
